//datasync bandung
import React, {
  useContext,
  useEffect,
  useState,
  useRef,
  useCallback,
} from "react";

import { usePouchDB, dataBkkbn, dataRekap } from "./PouchDBProvider";
import axios from "axios";
import { addHours } from "date-fns";
import Swal from "sweetalert2";

// import MemoryStream from 'memorystream';
const DataSyncContext = React.createContext();

export function useDataSync() {
  return useContext(DataSyncContext);
}

export default function DataSyncProvider(props) {
  const USER_KEY_PG = process.env.REACT_APP_USER_KEY_PROXY_GATEWAY;
  const REACT_APP_API_DEVELOPMENT_URL =
    process.env.REACT_APP_API_DEVELOPMENT_URL;
  const REACT_APP_API_CONFIG_URL = process.env.REACT_APP_API_CONFIG_URL;
  const REACT_APP_API_CONFIG_URL_NEW = process.env.REACT_APP_API_CONFIG_URL_NEW;

  //beda
  const {
    logoutAndClearLocal,
    user: { metadata },
  } = usePouchDB();
  //new
  const replicateBkkbn = useRef();
  const [isManualSyncing, setManualSyncing] = useState(false);
  const [lockWilayah, setLockWilayah] = useState("false");
  const [lockTarget, setLockTarget] = useState("false");
  const [lastSync, setLastSync] = useState("");
  const [flag, setFlag] = useState(false);

  const [isSyncing, setSyncing] = useState({
    syncKK: false,
    syncKB: false,
    syncPK: false,
    syncBkkbn: false,
    sysncRekap: false,
    statusNotif: { count: 0, message: [] },
  });

  const manualSync = useCallback(async () => {
    // console.log("METADATA >>>>> ", metadata);
    // console.log("METADATA >>>>> ", metadata.name);
    // console.log("ID KAB >>>>> ", metadata.wil_kabupaten.id_kabupaten);
    // console.log("manualsync run");
    const syncCheck = canSync(metadata);
    if (!syncCheck.allowed) {
      if (syncCheck.wait > 300) {
        Swal.fire({
          title: "Notifikasi",
          text: `Sinkronisasi hanya bisa dilakukan 1 jam sekali.`,
          icon: "warning",
          confirmButtonText: "OK",
        });
      } else if (syncCheck.wait < 300) {
        Swal.fire({
          title: "Notifikasi",
          text: `Sinkronisasi hanya bisa dilakukan 5 menit sekali.`,
          icon: "warning",
          confirmButtonText: "OK",
        });
      }
      setManualSyncing(false);
      return;
    }

    setManualSyncing(true);

    // === Cek Status User Aktif ===
    const ls = await localStorage.getItem("lastSync");
    if (ls) {
      setLastSync(ls);
    }
    let cekFindIdKab = false;
    try {
      let uname = metadata.nameProses;
      // console.log(uname, "<<<<<<< UNAME");
      // if (uname.substring(0, 3) == 'opr') {
      //   uname = uname.split('_')[0];
      // }

      const getStatusUser = await axios.get(
        REACT_APP_API_DEVELOPMENT_URL + "/auth/getStatusUser?username=" + uname,
        {
          // headers: { user_key: USER_KEY_PG }
          headers: { Authorization: "Basic YWRtaW46cGFzc3dvcmQ=" },
        }
      );

      // console.log("URL STATUS >>> ", getStatusUser);

      if (getStatusUser.data.isActive !== true) {
        Swal.fire({
          title: "Logout",
          text: "Sesi login anda telah berakhir, silakan login ulang.",
          icon: "warning",
          confirmButtonText: "Ya",
          confirmButtonColor: "#3085d6",
        }).then((result) => {
          if (result.value) {
            localStorage.removeItem("username");
            localStorage.removeItem("password");
            localStorage.removeItem("users");
            localStorage.removeItem("opr");
            logoutAndClearLocal();
          }
        });
      }

      const url_getListKabupatenNotActived =
        REACT_APP_API_CONFIG_URL + "/pk/pwaConfig/getListKabupatenNotActived";
      const res = await axios.get(url_getListKabupatenNotActived, {
        headers: { Authorization: "Basic YWRtaW46cGFzc3dvcmQ=" },
      });
      const { data } = await res;
      // console.log("DATA >>>>> ", data);
      const idkec = metadata?.wil_kecamatan?.id_kecamatan;
      // console.log("ID KECAMATAN >>> ", idkec);

      // const url_GetPk = REACT_APP_API_CONFIG_URL_NEW + "pk/api/v1/getPk";
      // console.log("url_GetPk >>> ", url_GetPk);

      // const requestBody = {
      //   username: metadata.name,
      //   id_rt: metadata.wil_rw[0]?.wil_rt[0]?.id_rt || "",
      //   periode_sensus: new Date().getFullYear(),
      // };
      // console.log("requestBody >>> ", requestBody);
      // const res = await axios.post(url_GetPk, requestBody);
      // const { data } = await res;
      // console.log("DATA >>>>> ", data);

      if (Object.keys(data).length > 0 && data.idKab !== "") {
        const arrKabNotActive = data.idKab.split(",");
        const usedIdKab = metadata.wil_kabupaten.id_kabupaten;
        // console.log(metadata.wil_kabupaten, 'id kab');
        // console.log(arrKabNotActive, 'data');
        cekFindIdKab = arrKabNotActive.find((el) => +el === +usedIdKab);
      }
    } catch (error) {
      console.log("<< 1. ERROR >>> ", error);
    }

    // console.log(cekFindIdKab, "cek find locked id kab");
    if (!cekFindIdKab) {
      setLockWilayah("false");
      await localStorage.setItem("lockWilayah", "false");
      await localStorage.setItem("lockTarget", "false");
      // await DataSyncProvider();
      // const now = new Date().format('DD-MM HH:mm:ss');
      const now = new Date().setDate("DD-MM HH:mm:ss");
      await localStorage.setItem("lastSync", now);
      setLastSync(now);
      //refresh data
      setFlag(false);
      setFlag(true);
    } else {
      setLockWilayah("true");
      setLockTarget("true");
      await localStorage.setItem("lockWilayah", "true");
      await localStorage.setItem("lockTarget", "true");
    }
    // setManualSyncing(false);
    // === End Cek Status User Aktif ===
    const opr = localStorage.getItem("opr");
    const localRw = localStorage.getItem("rw");
    const db_name = localStorage.getItem("db_name");
    const remote_base = localStorage.getItem("remote_base");
    const url = remote_base + "/" + db_name;
    const url_split = remote_base ? remote_base.split("/") : "";
    const couchdb = url_split[url_split.length - 1];

    // console.log(
    //   metadata?.wil_kecamatan?.id_kecamatan,
    //   " <<<<<<<<<<<<<<<< DATA USER"
    // );

    function canSync(metadata) {
      const userKey = metadata.nameProses;
      const syncInfo = JSON.parse(
        localStorage.getItem("syncInfo_" + userKey) || "{}"
      );
      const now = Date.now();

      if (syncInfo.status === "success" && syncInfo.lastSync) {
        if (now - syncInfo.lastSync < 60 * 60 * 1000) {
          return {
            allowed: false,
            wait: Math.ceil(
              (60 * 60 * 1000 - (now - syncInfo.lastSync)) / 1000
            ),
          };
        }
      }

      if (syncInfo.status === "fail" && syncInfo.lastFail) {
        if (syncInfo.failCount >= 3) {
          if (now - syncInfo.lastFail < 5 * 60 * 1000) {
            return {
              allowed: false,
              wait: Math.ceil(
                (5 * 60 * 1000 - (now - syncInfo.lastFail)) / 1000
              ),
            };
          } else {
            localStorage.setItem(
              "syncInfo_" + userKey,
              JSON.stringify({ failCount: 0 })
            );
          }
        }
      }

      return { allowed: true };
    }

    let selector = {
      user_name: metadata.nameProses,
      // periode_sensus: "2025",
    };

    if (opr === "true" && localRw !== "false") {
      selector = {
        user_name: metadata.nameProses,
        id_rw: localRw,
        // periode_sensus: "2025",
      };
    }

    try {
      //get data form server
      const data_selector = {
        selector: selector,
        limit: 10000,
      };

      const idkec = metadata?.wil_kecamatan?.id_kecamatan;
      // console.log("ID KECAMATAN >>> ", idkec);

      const url_GetPk = REACT_APP_API_CONFIG_URL_NEW + "pk/api/v1/getPk";
      // console.log("url_GetPk >>> ", url_GetPk);

      const requestBody = {
        username: metadata.nameProses,
      };
      // console.log("requestBody >>> ", requestBody);
      // const res = await axios.post(url_GetPk, requestBody, {
      //   headers: {
      //     Authorization: "Basic YWRtaW46cGFzc3dvcmQ=",
      //     user_id: metadata.id,
      //   },
      // });

      const res = await axios.post(url_GetPk, requestBody, {
        headers: { Authorization: "Basic YWRtaW46cGFzc3dvcmQ=" },
      });
      const { data } = await res;

      const userKey = metadata.nameProses;
      if (data.data && data.data.length > 30) {
        localStorage.setItem(
          "syncInfo_" + userKey,
          JSON.stringify({
            status: "success",
            lastSync: Date.now(),
            failCount: 0,
          })
        );
      } else {
        const syncInfo = JSON.parse(
          localStorage.getItem("syncInfo_" + userKey) || "{}"
        );
        const failCount = (syncInfo.failCount || 0) + 1;
        localStorage.setItem(
          "syncInfo_" + userKey,
          JSON.stringify({
            status: "fail",
            lastFail: Date.now(),
            failCount,
          })
        );
      }

      // const res = await axios.post(
      //   url +
      //     "/_find?couchdb=" +
      //     couchdb +
      //     "&database-name=" +
      //     db_name +
      //     "&idKec=" +
      //     idkec,
      //   data_selector,
      //   {
      //     // headers: { user_key: USER_KEY_PG }
      //     headers: { Authorization: "Basic YWRtaW46cGFzc3dvcmQ=" },
      //   }
      // );
      // console.log("REPLICATE DATA >>> ", res);

      // const { data } = await res;
      // console.log("ini data replikasi >>> ", data);

      // console.log("DATA >>>>>>>>>>>>>>>>>>>>>>>>>>>>>> ", data.length)
      let dataRemote;
      if (metadata.name.substring(0, 3) === "opr") {
        console.log(true);
        console.log(metadata.wil_rw[0].id_rw);

        const filteredData = data.data.filter(
          (item) => item.id_rw == metadata.wil_rw[0].id_rw
        );
        console.log(filteredData);

        dataRemote = { docs: { data: filteredData } };
      } else {
        dataRemote = { docs: data };
      }

      // const dataRemote = await dataBkkbn.remote.find({
      //     selector,
      //     limit: 10000
      // });
      const serverDataCount = dataRemote.docs.data.filter(
        (item) => item.status_sensus !== "Delete"
      ).length;
      localStorage.setItem("dataServerCount", serverDataCount.toString());
      // console.log("Jumlah data server:", serverDataCount);
      // console.log("get data form server => ", dataRemote);

      //get data form local
      const dataLocal = await dataBkkbn.local.find({
        selector,
      });

      const newDataRemote = [];
      const dataRekapRemote = [];

      dataRemote.docs.data.reverse().forEach((item) => {
        // console.log("item remote flag retrieve => ", item.flag_retrieve);

        newDataRemote.push(item);
        if (item.group === "dataRekap") {
          dataRekapRemote.push(item);
        }
      });
      // console.log("get data form server new data remote => ", newDataRemote);
      // console.log(
      //   "get data form server data rekap remote => ",
      //   dataRekapRemote
      // );

      // setManualSyncing(false);

      const newDataLocal = [];
      const dataRekapLocal = [];
      dataLocal.docs.reverse().forEach((item) => {
        newDataLocal.push(item);

        if (item.group === "dataRekap") {
          dataRekapLocal.push(item);
        }
      });

      // console.log("get data form local new data local => ", newDataLocal);

      // console.log("get data form server => ", newDataRemote.filter(el => el._id === "1617205298507p3573031008Rofiatul_Smart"))
      // console.log("get data form local => ", newDataLocal)
      // console.log("get data rekap form server => ", dataRekapRemote);
      // console.log("get data rekap form lokal => ", dataRekapLocal)

      let _rev;
      // console.log("aaaaaaaaaaa", newDataRemote.length);
      // console.log("bbbbbbbbbbb", newDataLocal.length);

      if (newDataRemote.length > 0 && newDataLocal.length == 0) {
        // console.log("run remote > 0 local = 0")
        for (let i = 0; i < newDataRemote.length; i++) {
          //console.log("run insert => ", newDataRemote[i])
          try {
            let dataInsert = {
              ...newDataRemote[i],
              _rev,
            };

            if (newDataRemote[i].status_sensus == "") {
              dataInsert = {
                ...newDataRemote[i],
                status_sensus: "Tersimpan",
                _rev,
              };
            }
            // console.log(dataInsert, 'data insert')

            //if (newDataRemote[i].status_sensus != "Delete") {
            // console.log("data insert => ", dataInsert);

            await dataBkkbn["local"].put(dataInsert);

            //}
          } catch (error) {
            console.error("<< 2. error sync => ", error);
          }
        }
      } else if (newDataRemote.length > 0 && newDataLocal.length > 0) {
        // console.log("run remote > 0 local > 0")
        // console.log(true);
        for (let i = 0; i < newDataRemote.length; i++) {
          //if (newDataRemote[i].status_sensus != "Delete") {
          const cek = newDataLocal.find((data) => {
            if (newDataRemote[i]._id == data._id) {
              if (
                data.status_sensus != "" &&
                newDataRemote[i].status_sensus != ""
              ) {
                if (data.status_sensus != newDataRemote[i].status_sensus) {
                  // if (data.status_sensus) {
                  return data;
                } else {
                  return false;
                }
              }
              return false;
            }
            return false;
          });
          // console.log("CEK >>>>>>>>>>>>>>>>>>>>>>>>>>>> ", i, cek);
          // console.log("CEK >>>>>>>>>>>>>>>>>>>>>>>>>>>> ", i, cek);

          if (cek) {
            // console.log(true);

            try {
              //console.log("renew sync update => ", newDataRemote[i].status_sensus)

              let dataInsert = {
                ...newDataRemote[i],
                _rev: cek._rev,
              };

              if (newDataRemote[i].status_sensus === "") {
                dataInsert = {
                  ...newDataRemote[i],
                  status_sensus: "Tersimpan",
                  _rev: cek._rev,
                };
              }
              // console.log("data insert cek => ", dataInsert);

              await dataBkkbn["local"].put(dataInsert);
            } catch (error) {
              console.log("<< 3. error renew sync => ", error);
            }
          }

          const cekNull = newDataLocal.find((data) => {
            if (newDataRemote[i]._id === data._id) {
              if (
                data.status_sensus === "" &&
                newDataRemote[i].status_sensus === ""
              ) {
                return data;
              }
              return false;
            }
            return false;
          });
          // console.log("CEK NULL >>>>>>>>>>>>>>>>>>>>>>>>>>>> ", i, cekNull);

          if (cekNull) {
            try {
              //console.log("renew null status local => ", cekNull.status_sensus)

              if (cekNull.status_sensus === "") {
                let dataInsert = {
                  ...cekNull,
                  status_sensus: "Tersimpan",
                  _rev: cekNull._rev,
                };

                await dataBkkbn["local"].put(dataInsert);
              }

              if (cekNull.sts_keluarga !== null) {
                // let dataInsert = {
                //   ...cekNull,
                //   status_sensus: "",
                //   _rev: newDataRemote[i]._rev,
                // };

                await axios
                  .post(
                    REACT_APP_API_CONFIG_URL_NEW +
                      "pk/api/v1/getPkByIdfrm?idfrm=" +
                      cekNull._id +
                      "&username=" +
                      cekNull.user_name,
                    {},
                    { headers: { Authorization: "Basic YWRtaW46cGFzc3dvcmQ=" } }
                  )
                  .then(async (res) => {
                    let insertData = {
                      ...res.data.data[0],
                      audit_trail: "Insert From " + os + " At " + time,
                    };
                    let os = window.navigator.userAgent;
                    let time = new Date()
                      .toLocaleString()
                      .replace(",", "")
                      .replace(/:.. /, " ");

                    if (cekNull.sts_keluarga !== null) {
                      insertData = {
                        ...res.data.data[0],
                        status_sensus: "",
                        audit_trail: "Insert From " + os + " At " + time,
                      };
                    }

                    try {
                      await axios.post(
                        REACT_APP_API_CONFIG_URL_NEW + "pk/api/v1/save",
                        insertData,
                        {
                          headers: {
                            Authorization: "Basic YWRtaW46cGFzc3dvcmQ=",
                          },
                        }
                      );
                    } catch (error) {
                      console.error("Error saat insert data:", error);
                    }
                  })
                  .catch((error) => console.log("Error:", error));
                // await dataBkkbn['remote'].put(dataInsert);
                // console.log("data insert cek null => ", dataInsert);

                // await axios.put(
                //   url +
                //     "/" +
                //     dataInsert._id +
                //     "/_put?couchdb=" +
                //     couchdb +
                //     "&database-name=" +
                //     db_name +
                //     "&_id=" +
                //     dataInsert._id +
                //     "&idKec=" +
                //     metadata?.wil_kecamatan?.id_kecamatan,
                //   dataInsert,
                //   {
                //     // headers: { user_key: USER_KEY_PG }
                //     headers: { Authorization: "Basic YWRtaW46cGFzc3dvcmQ=" },
                //   }
                // );

                // await axios.post(
                //   REACT_APP_API_CONFIG_URL_NEW + "pk/api/v1/save",
                //   dataInsert
                // );
              }
            } catch (error) {
              console.log("<< 4. error renew sync => ", error);
            }
          }

          const refreshLocal = newDataLocal.find((data) => {
            if (newDataRemote[i]._id === data._id) {
              if (newDataRemote[i].status_sensus === "") {
                return data;
              }
              return false;
            }
            return false;
          });

          if (refreshLocal) {
            try {
              //console.log("renew status local => ", refreshLocal)

              if (
                refreshLocal.status_sensus === "Tersimpan" &&
                refreshLocal.status_draft === "2"
              ) {
                // console.log("renew status tersimpan => ", refreshLocal)
                let dataInsert = {
                  ...newDataRemote[i],
                  status_sensus: "Tersimpan",
                  _rev: refreshLocal._rev,
                };

                await dataBkkbn["local"].put(dataInsert);
              } else if (
                refreshLocal.status_sensus !== "Tersimpan" &&
                refreshLocal.status_draft === "2"
              ) {
                // console.log("renew status not tersimpan => ", refreshLocal)
                let dataInsert = {
                  ...newDataRemote[i],
                  status_sensus: "Tersimpan",
                  _rev: refreshLocal._rev,
                };

                await dataBkkbn["local"].put(dataInsert);
              }
            } catch (error) {
              console.log("<< 5. error renew sync => ", error);
            }
          }

          if (newDataRemote[i].status_sensus === "Tersimpan") {
            try {
              // console.log("run fix status tersimpan on server")
              // let dataInsert = {
              //   ...newDataRemote[i],
              //   status_sensus: "",
              // };

              await axios
                .post(
                  REACT_APP_API_CONFIG_URL_NEW +
                    "pk/api/v1/getPkByIdfrm?idfrm=" +
                    newDataRemote[i]._id +
                    "&username=" +
                    newDataRemote[i].user_name,
                  {},
                  { headers: { Authorization: "Basic YWRtaW46cGFzc3dvcmQ=" } }
                )
                .then(async (res) => {
                  let os = window.navigator.userAgent;
                  let time = new Date()
                    .toLocaleString()
                    .replace(",", "")
                    .replace(/:.. /, " ");

                  const insertData = {
                    ...res.data.data[0],
                    status_sensus: "",
                    audit_trail: "Insert From " + os + " At " + time,
                  };

                  try {
                    await axios.post(
                      REACT_APP_API_CONFIG_URL_NEW + "pk/api/v1/save",
                      insertData,
                      {
                        headers: {
                          Authorization: "Basic YWRtaW46cGFzc3dvcmQ=",
                        },
                      }
                    );
                  } catch (error) {
                    console.error("Error saat insert data:", error);
                  }
                })
                .catch((error) => console.log("Error:", error));
              // await dataBkkbn['remote'].put(dataInsert);
              // await axios.put(
              //   url +
              //     "/" +
              //     dataInsert._id +
              //     "/_put?couchdb=" +
              //     couchdb +
              //     "&database-name=" +
              //     db_name +
              //     "&_id=" +
              //     dataInsert._id +
              //     "&idKec=" +
              //     metadata?.wil_kecamatan?.id_kecamatan,
              //   dataInsert,
              //   {
              //     // headers: { user_key: USER_KEY_PG }
              //     headers: { Authorization: "Basic YWRtaW46cGFzc3dvcmQ=" },
              //   }
              // );

              // await axios.post(
              //   REACT_APP_API_CONFIG_URL_NEW + "pk/api/v1/save",
              //   dataInsert
              // );
            } catch (error) {
              console.error("<< 6. error  => ", error);
            }
          }
          //}
        }
        // console.log("aaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaa", newDataLocal);

        for (let i = 0; i < newDataLocal.length; i++) {
          const cek = newDataRemote.find((data) => {
            if (newDataLocal[i]._id === data._id) {
              return data;
            }
            return false;
          });

          if (!cek) {
            // console.log("CEK >>>>>>>>>>>>>>>>>>>>>>>>>>>> ", newDataLocal[i]);
            try {
              let dataInsert = {
                ...newDataLocal[i],
                _rev,
              };
              // console.log("data insert cek not found => ", dataInsert);
              if (newDataLocal[i].status_sensus !== "Delete") {
                // console.log("run insert not found => ", dataInsert);

                // await axios.put(
                //   url +
                //     "/" +
                //     dataInsert._id +
                //     "/_put?couchdb=" +
                //     couchdb +
                //     "&database-name=" +
                //     db_name +
                //     "&_id=" +
                //     dataInsert._id +
                //     "&idKec=" +
                //     metadata?.wil_kecamatan?.id_kecamatan,
                //   dataInsert,
                //   {
                //     // headers: { user_key: USER_KEY_PG }
                //     headers: { Authorization: "Basic YWRtaW46cGFzc3dvcmQ=" },
                //   }
                // );

                // await axios
                //   .post(
                //     REACT_APP_API_CONFIG_URL_NEW +
                //       "pk/api/v1/getPkByIdfrm?idfrm=" +
                //       newDataLocal[i]._id +
                //       "&username=" +
                //       newDataLocal[i].user_name,
                //     {},
                //     { headers: { Authorization: "Basic YWRtaW46cGFzc3dvcmQ=" } }
                //   )
                //   .then(async (res) => {
                //     let os = window.navigator.userAgent;
                //     let time = new Date()
                //       .toLocaleString()
                //       .replace(",", "")
                //       .replace(/:.. /, " ");
                //     const insertData = {
                //       ...res.data.data[0],
                //       audit_trail: "Insert From " + os + " At " + time,
                //     };

                try {
                  await axios.post(
                    REACT_APP_API_CONFIG_URL_NEW + "pk/api/v1/save",
                    dataInsert,
                    {
                      headers: {
                        Authorization: "Basic YWRtaW46cGFzc3dvcmQ=",
                      },
                    }
                  );
                } catch (error) {
                  console.error("Error saat insert data:", error);
                }
                // })
                // .catch((error) => console.log("Error:", error));

                // await axios.post(
                //   REACT_APP_API_CONFIG_URL_NEW + "pk/api/v1/save",
                //   dataInsert,
                //   { headers: { Authorization: "Basic YWRtaW46cGFzc3dvcmQ=" } }
                // );
              }

              if (newDataLocal[i].status_sensus === "") {
                let dataLocal = {
                  ...newDataLocal[i],
                  status_sensus: "Tersimpan",
                };

                await dataBkkbn["local"].put(dataLocal);
              }
            } catch (error) {
              console.log("<< 7. error renew sync => ", error);
            }
          } else {
            if (
              newDataLocal[i].status_draft === "1" &&
              newDataLocal[i].status_sensus !== "Delete"
            ) {
              if (cek.status_draft === "2" && cek.status_sensus !== "Delete") {
                // console.log("run draft => ", cek)
                try {
                  let dataLocal;
                  if (cek.status_sensus === "") {
                    dataLocal = {
                      ...cek,
                      status_sensus: "Tersimpan",
                      _rev: newDataLocal[i]._rev,
                    };
                  } else {
                    dataLocal = {
                      ...cek,
                      _rev: newDataLocal[i]._rev,
                    };
                  }

                  await dataBkkbn["local"].put(dataLocal);
                } catch (error) {
                  console.log("<< 8. error renew sync => ", error);
                }
              } else if (
                cek.status_draft === "1" &&
                cek.status_sensus !== "Delete"
              ) {
                // console.log("run draft on drfat => ", cek)
                try {
                  let dataLocal = {
                    ...cek,
                    status_sensus: "Tersimpan",
                    _rev: newDataLocal[i]._rev,
                  };

                  await dataBkkbn["local"].put(dataLocal);
                } catch (error) {
                  console.log("<< 9. error renew sync => ", error);
                }
              }
            }

            if (newDataLocal[i].status_sensus === "Delete") {
              if (cek.status_sensus === "") {
                // console.log("run delete to tersimpan => ", cek);
                try {
                  let dataLocal = {
                    ...cek,
                    status_sensus: "Tersimpan",
                    _rev: newDataLocal[i]._rev,
                  };

                  await dataBkkbn["local"].put(dataLocal);
                } catch (error) {
                  console.log("<< 10. error renew sync => ", error);
                }
              }
            } else if (cek.status_sensus === "Delete") {
              if (newDataLocal[i].status_sensus === "Tersimpan") {
                // console.log("run delete to delete => ", cek);
                try {
                  let dataLocal = {
                    ...cek,
                    _rev: newDataLocal[i]._rev,
                  };

                  await dataBkkbn["local"].put(dataLocal);
                } catch (error) {
                  console.log("<< 11. error renew sync => ", error);
                }
              }
            }
          }

          const cekStatus = newDataRemote.find((data) => {
            if (newDataLocal[i].status_sensus !== "Delete") {
              if (newDataLocal[i]._id === data._id) {
                if (data.status_sensus === "") {
                  if (
                    newDataLocal[i].status_sensus !== "" &&
                    newDataLocal[i].status_sensus !== "Tersimpan"
                  ) {
                    return data;
                  }
                  return false;
                }
                return false;
              }
              return false;
            }
            return false;
          });

          if (cekStatus) {
            if (
              cekStatus.status_draft === "2" &&
              newDataLocal[i].status_draft === "2"
            ) {
              // console.log("masuk => ", cekStatus)
              try {
                let dataInsert = {
                  ...cekStatus,
                  status_sensus: "Tersimpan",
                  _rev: newDataLocal[i]._rev,
                };

                await dataBkkbn["local"].put(dataInsert);
              } catch (error) {
                console.log("<< 12. error renew sync => ", error);
              }
            }
          }
        }

        //rekap rt
        if (dataRekapRemote.length > 0) {
          // console.log("run rekap update")
          for (let i = 0; i < dataRekapRemote.length; i++) {
            const cek = dataRekapLocal.find((data) => {
              if (dataRekapRemote[i]._id === data._id) {
                return data;
              }
              return false;
            });

            if (cek) {
              // console.log("cek rekap => ", cek)
              const dataRekapNew = {
                ...dataRekapRemote[i],
                _rev: cek._rev,
              };

              try {
                await dataBkkbn["local"].put(dataRekapNew);
              } catch (error) {
                console.log("<< 13. error renew sync => ", error);
              }
            } else {
              const dataRekapNew = {
                ...dataRekapRemote[i],
              };
              delete dataRekapNew._rev;

              try {
                await dataBkkbn["local"].put(dataRekapNew);
              } catch (error) {
                console.log("<< 14. error renew sync => ", error);
              }
            }
          }
        }
      }

      if (newDataRemote.length > newDataLocal.length) {
        // console.log("run remote > local")
        for (let i = 0; i < newDataRemote.length; i++) {
          //if (newDataRemote[i].status_sensus != "Delete") {

          const cek = newDataLocal.some((data) => {
            if (newDataRemote[i]._id === data._id) {
              return true;
            }
            return false;
          });
          // console.log("ini data remotenya>>>", newDataRemote[i]);
          // console.log("ini data localnya>>>", newDataLocal);

          // console.log("CEK >>>", cek);

          if (!cek) {
            // const selector = {
            //   _id: {
            //     $eq: "1725439049957opr6208011004opr6208011004operatorpadang3",
            //   },
            // };
            // const query = await dataBkkbn.local.find({ selector });
            // console.log("data hasil selector>>", query);

            try {
              let dataInsert = {
                ...newDataRemote[i],
                _rev,
              };

              if (newDataRemote[i].status_sensus === "") {
                // console.log("run status_sensus === ''");
                dataInsert = {
                  ...newDataRemote[i],
                  status_sensus: "Tersimpan",
                  _rev,
                };
              }
              // console.log("data insert local>>", dataInsert);
              delete dataInsert._rev;

              await dataBkkbn["local"].put(dataInsert);
            } catch (error) {
              console.log("<< 15. error renew sync => ", error);
            }
            //}
          }
        }
      }

      if (newDataLocal.length > newDataRemote.length) {
        // console.log("run local > remote")
        for (let i = 0; i < newDataLocal.length; i++) {
          try {
            // Mengecek apakah data lokal ada di remote
            const cek = newDataRemote.find(
              (data) => newDataLocal[i]._id === data._id
            );

            if (!cek) {
              // let dataInsert = {
              //   ...newDataLocal[i],
              //   _rev,
              // };

              // if (newDataLocal[i].status_sensus === "Tersimpan") {
              //   dataInsert = {
              //     ...newDataLocal[i],
              //     status_sensus: "",
              //     _rev,
              //   };
              // }

              await axios
                .post(
                  REACT_APP_API_CONFIG_URL_NEW +
                    "pk/api/v1/getPkByIdfrm?idfrm=" +
                    newDataLocal[i]._id +
                    "&username=" +
                    newDataLocal[i].user_name,
                  {},
                  { headers: { Authorization: "Basic YWRtaW46cGFzc3dvcmQ=" } }
                )
                .then(async (res) => {
                  let os = window.navigator.userAgent;
                  let time = new Date()
                    .toLocaleString()
                    .replace(",", "")
                    .replace(/:.. /, " ");
                  let dataInsert = {
                    ...res.data.data[0],
                    audit_trail: "Insert From " + os + " At " + time,
                  };
                  if (res.data.data[0].status_sensus === "Tersimpan") {
                    dataInsert = {
                      ...res.data.data[0],
                      status_sensus: "",
                      audit_trail: "Insert From " + os + " At " + time,
                    };
                  }
                  try {
                    await axios.post(
                      REACT_APP_API_CONFIG_URL_NEW + "pk/api/v1/save",
                      dataInsert,
                      {
                        headers: {
                          Authorization: "Basic YWRtaW46cGFzc3dvcmQ=",
                        },
                      }
                    );
                  } catch (error) {
                    console.error("Error saat insert data:", error);
                  }
                })
                .catch((error) => console.log("Error:", error));

              // console.log("data insert cek not found => ", dataInsert);

              // Melakukan PUT request ke server
              // await axios.put(
              //   url +
              //     "/" +
              //     dataInsert._id +
              //     "/_put?couchdb=" +
              //     couchdb +
              //     "&database-name=" +
              //     db_name +
              //     "&_id=" +
              //     dataInsert._id +
              //     "&idKec=" +
              //     metadata?.wil_kecamatan?.id_kecamatan,
              //   dataInsert,
              //   {
              //     headers: { Authorization: "Basic YWRtaW46cGFzc3dvcmQ=" },
              //   }
              // );
              // await axios.put(
              //   url +
              //     "/" +
              //     dataInsert._id +
              //     "/_put?couchdb=" +
              //     couchdb +
              //     "&database-name=" +
              //     db_name +
              //     "&_id=" +
              //     dataInsert._id +
              //     "&idKec=" +
              //     metadata?.wil_kecamatan?.id_kecamatan,
              //   dataInsert,
              //   {
              //     headers: { Authorization: "Basic YWRtaW46cGFzc3dvcmQ=" },
              //   }
              // );

              // await axios.post(
              //   REACT_APP_API_CONFIG_URL_NEW + "pk/api/v1/save",
              //   dataInsert,
              //   {
              //     headers: {
              //       Authorization: "Basic YWRtaW46cGFzc3dvcmQ=",
              //     },
              //   }
              // );
              // await axios.post(
              //   REACT_APP_API_CONFIG_URL_NEW + "pk/api/v1/save",
              //   dataInsert
              // );

              if (newDataLocal[i].status_sensus === "") {
                let dataLocal = {
                  ...newDataLocal[i],
                  status_sensus: "Tersimpan",
                };
                await dataBkkbn["local"].put(dataLocal);
              }
            }
          } catch (error) {
            // Menghentikan loop jika terjadi error
            console.error("<< 16. Error during sync: ", error);
            break;
          }
        }
      }

      setManualSyncing(false);
      localStorage.setItem("forceRefreshData", "true");
      // window.location.reload();
    } catch (error) {
      console.log("<< 17. error sync => ", error);
      setManualSyncing(false);
    }
  }, [metadata]);

  useEffect(() => {
    const first = localStorage.getItem("first");
    // console.log(first, "<< first sync run")
    if (first) {
      manualSync();
      localStorage.removeItem("first");
    }
    //manualSync()
  }, []);

  // console.log(isSyncing)

  return (
    <DataSyncContext.Provider
      value={{
        isSyncing,
        manualSync,
        isManualSyncing,
      }}
    >
      {props.children}
    </DataSyncContext.Provider>
  );
}
